import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';

export const Support = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2} style={{ margin: "0 1rem 2.5rem" }}>
                {storyData.data.heading}
            </h1>
            <div
                className={styles.flexWrapContainer}
                style={{ flexDirection: storyData.data.causeCounts.length < 6 ? "column" : 'row' }}
            >
                {storyData.data.causeCounts.map(element =>
                    <p key={element[0]} className={styles.purpleTag}>
                        {element[0].toLowerCase()}{element[1] > 1 && <span>&nbsp;&nbsp;{element[1]}</span>}
                    </p>
                )}
            </div>
        </StoryWrapper>
    )
}